import type { FC } from "react"
import React from "react"
import { isAddress } from "@ethersproject/address"
import type { StackProps } from "@chakra-ui/react"
import { Text } from "@chakra-ui/react"

import AddressTooltip from "common/components/AddressTooltip"
import Link from "common/components/Link"
import { ROUTES } from "common/constants/routes"
import { shortString, subString } from "common/helpers/string"
import { getWhiteLabelRoute } from "whitelabel/utils/breadcrumb"
import { getDisplayName } from "user/helpers/user"
import type { AUserIdentity } from "common/components/columns/UserIdentity"

type UserIdentityProps = {
  account?: AUserIdentity
  isGnosisSafe?: boolean
  isTruncated?: boolean
  isWhiteLabel?: boolean
  profileLink?: string
  displayProfileLink?: boolean
  slug?: string
  displayCard?: boolean
}

const SimpleTextUserIdentity: FC<UserIdentityProps & StackProps> = ({
  account,
  isWhiteLabel = false,
  profileLink,
  displayProfileLink = true,
  slug,
  displayCard = false,
}) => {
  const getRoute = () => {
    if (!displayProfileLink) return undefined

    if (profileLink) return profileLink

    if (isWhiteLabel)
      return slug
        ? getWhiteLabelRoute(
            ROUTES.governance.delegate.profile(
              slug,
              account?.address as string,
            ),
          )
        : getWhiteLabelRoute(ROUTES.profile(account?.address as string))

    return slug
      ? ROUTES.governance.delegate.profile(slug, account?.address as string)
      : ROUTES.profile(account?.address as string)
  }
  const route = getRoute()

  const displayName = account ? getDisplayName(account) : null

  const displayNameText = () => {
    return (
      <AddressTooltip aria-label="Complete address" label={account?.address}>
        {displayName ? (
          <Text display="inline">
            {isAddress(displayName)
              ? shortString(displayName)
              : subString(displayName, displayCard ? 30 : 200)}
          </Text>
        ) : null}
      </AddressTooltip>
    )
  }

  return (
    <>
      {route ? (
        <Link href={route}>{displayNameText()}</Link>
      ) : (
        <> {displayNameText()}</>
      )}
    </>
  )
}

export default SimpleTextUserIdentity
